
import { Fraga } from "@/types/riskbedomning";

export const radiationRiskFragor: Fraga[] = [
  {
    id: "joniserande-stralning",
    text: "Finns det risk för exponering av joniserande strålning?",
    kategori: "Särskilda arbetsmiljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Riskerar otydlig källa, doskontroll, avgränsning/zon eller utrustningsval att medföra otillräckligt skydd mot exponering?",
      "Finns det risk att strålkällor förekommer i projektet utan att vara identifierade?",
      "Finns det risk att stråldoser för personal inte kontrolleras?",
      "Finns det risk att strålskyddsutrustning saknas eller är otillräcklig?",
      "Finns det risk att avgränsning av kontrollerade områden saknas eller är bristfällig?"
    ]
  }
];
